// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__xU4PX","footer":"ChangeClinic_footer__1FLft"};